import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../shared/Permissions/PermissionsContext';
import TokenService from '../services/token.service';
import Cookies from 'js-cookie';
// CryptoJS removed — decryption centralised in TokenService

/**
 * ProtectedRoute — guards a route by role and/or permission.
 *
 * Props:
 *   element            - The component to render if access is granted
 *   requiredRole       - e.g. "superadmin" — checks the org_id cookie against
 *                         the "superAdmin" sentinel (matches backend's
 *                         requireSuperAdmin), not the account's username
 *   requiredPermission - e.g. "users:write" — checks PermissionsContext array
 *
 * Both checks are optional. If neither is provided the route renders normally.
 * If either check fails the user is redirected to /dashboard.
 */
const ProtectedRoute = ({ element, requiredRole = null, requiredPermission = null }) => {
    const { permissions } = usePermissions();
    const orgId = TokenService.decryptData(Cookies.get('org_id'));

    // Role check — case-insensitive since callers pass "superadmin" lowercase
    // while the actual org_id sentinel value is "superAdmin".
    if (requiredRole && (!orgId || orgId.toLowerCase() !== requiredRole.toLowerCase())) {
        return <Navigate to="/dashboard" replace />;
    }

    // Permission check — was silently ignored before; now fully implemented
    if (requiredPermission && !permissions?.includes(requiredPermission)) {
        return <Navigate to="/dashboard" replace />;
    }

    return element;
};

ProtectedRoute.propTypes = {
    element:             PropTypes.element.isRequired,
    requiredRole:        PropTypes.string,
    requiredPermission:  PropTypes.string,
};

export default ProtectedRoute;